import React from "react";
import { Container } from "react-bootstrap";
import "./style.scss";
import { Link } from "react-router-dom";
import { Space, Table, Popconfirm, Button, Image, Input } from 'antd';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { apiAdminConfig } from "../../utils/api";
import useToast from "../../provider/Toast/useToast";
import PreviewPDF from "../../Component/previewPDF";
import { FilePdfOutlined } from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';



const Certificates = () => {
  const [certificate, setCertificate] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);

  const toast = useToast();
  const getCertificate = async () => {
    await apiAdminConfig.get('admin/certificate/getall').then((response) => {
      if (response?.data?.status) {
        setCertificate(response?.data?.data)
        setFilteredData(response?.data?.data)
      }
    }).catch((error) => {
      // const { response } = error;
      console.log("certificateError", error);
    })
  };

  React.useEffect(() => {
    setFilteredData(
      certificate.filter((item) =>
        item?.docId?.title?.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search]);


  React.useEffect(() => {
    getCertificate();
  }, []);

  const onDelete = async (id) => {
    await apiAdminConfig.delete(`admin/certificate/${id}`).then((response) => {
      if (response?.data.status) {
        toast({
          message: response?.data?.message,
          bg: 'success'
        });
        getCertificate();
      } else {
        toast({
          message: response?.data?.message,
          bg: 'danger'
        });
      }
    }).catch((error) => {
      const { response } = error;
      console.log("certificateError", error)
      toast({
        message: response?.data?.message,
        bg: "danger",
      });
    })
  };

  const columns = [
    {
      title: 'Sr no',
      dataIndex: '_id',
      key: 'Srno',
      render: (_, record, index) => {
        return (
          <>
            {index + 1}
          </>
        )
      }
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'Title',
      render: (_, record) => {
        return (
          <>
            {record?.docId?.title}
          </>
        )
      }
    },
    {
      title: 'Pdf',
      dataIndex: 'Pdf',
      key: 'Pdf',
      render: (_, record) => {
        return (
          <>
            {
              record?.certificate_files?.length > 0 ?
                record?.certificate_files?.map((item, index) => {
                  return (
                    <FilePdfOutlined style={{ fontSize: '30px' }}
                      onClick={() => window.open(item?.url, "_blank")}
                    />
                  )
                }
                ) : null
            }
          </>
        )
      }
    },
    {
      title: "Action",
      dataIndex: "action",
      key: 'Action',
      render: (_, record) => (
        <Space>
          <Link to={"/certificates/edit/" + record._id}>
            <Button
              type="primary"
              title="Edit"
              style={{ padding: "2px 4px" }}
            >
              {" "}
              <strong>
                {" "}
                <EditOutlined
                  style={{
                    fontWeight: "900",
                    fontSize: "16px",
                    verticalAlign: "middle",
                  }}
                />{" "}
              </strong>{" "}
            </Button>
          </Link>

          <Popconfirm
            title="Are you sure want to delete ?"
            key={record._id}
            onConfirm={() => onDelete(record._id)}
          >
            <Button danger type="primary" title="Delete" style={{ padding: "4px 8px" }}>
              <strong>
                <DeleteOutlined
                  style={{
                    fontWeight: "900",
                    fontSize: "16px",
                    verticalAlign: "middle",
                  }}
                />
              </strong>
            </Button>
          </Popconfirm>
        </Space>
      ),
    }
  ]
  return (
    <main id="certificates">
      <Container className="admin_padding">
        <div className="admin_padding_table">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Assigned Certificates</h3>
            </div>
            <div className="table-hader-filter">
              <Input
                placeholder="Search"
                prefix={<SearchOutlined />}
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                style={{
                  borderRadius: "5px",
                  width: "300px",
                  height: "40px",
                }}
              />
            </div>
            <Link to="/certificates/create" className="page_add_btn">
              Add New
            </Link>
          </div>
          <Table dataSource={filteredData} columns={columns} scroll={{ x: 525 }} />
        </div>
      </Container>
    </main>
  );
};

export default Certificates;
